module.exports = __webpack_public_path__ + "images/emoji/clock1.e5c629f4ab9c01050d7d.png";